import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./utils/i18n/config";
import ErrorBoundary, {
  setupGlobalErrorHandlers,
} from "./components/wrappers/ErrorBoundary";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const root = ReactDOM.createRoot(document.getElementById("root"));

setupGlobalErrorHandlers();

const { pathname, search, hash } = window.location;
if (pathname.startsWith("//")) {
  window.history.replaceState(
    null,
    "",
    pathname.replace(/^\/+/, "/") + search + hash,
  );
}
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
    },
  },
});
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
